import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {OperationalStatus, OperationalStatusCardView, operationalStatusLabel,} from '../operational-readiness.models';
import {OperationalWarningCardComponent} from '../operational-warning-card/operational-warning-card.component';

/**
 * Presentation-only status card.
 * Parents map platform state into OperationalStatusCardView.
 */
@Component({
    selector: 'app-operational-status-card',
    standalone: true,
    imports: [CommonModule, OperationalWarningCardComponent],
    templateUrl: './operational-status-card.component.html',
    styleUrl: './operational-status-card.component.css',
})
export class OperationalStatusCardComponent {
    @Input({required: true}) card!: OperationalStatusCardView;

    get status(): OperationalStatus {
        return this.card?.status ?? 'unknown';
    }

    get statusLabel(): string {
        return operationalStatusLabel(this.status, this.card?.statusLabel);
    }
}
